import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "hooks/useAuthContext";
import useApiCall from "hooks/useApiCall";
import { postLogOut } from "api/services/user-service";
import { RoutePaths } from "constants/RoutePaths";

export const useLogout = () => {
    const navigate = useNavigate();    
    const { userDispatch } = useAuthContext();
    const { callAPI } = useApiCall(postLogOut, 'logout.success', 'logout.error');

    const logout = useCallback(async () => {
        const response = await callAPI(null);

        if (response.success) {
            userDispatch({ type: 'LOGOUT' });
            navigate(RoutePaths.LOGIN)
        }
    }, [callAPI, navigate, userDispatch]);
    
    return logout;
};